import {Urls} from "@bounce/shared/consumer/declarations";

export const consumerUrls: Urls = {
  error: {
    url: "/error",
    path: "error",
    titleKey: "Error",
  },
  agentConsent: {
    url: "/agent-consent",
    path: "agent-consent",
    titleKey: "Agent consent",
  },
  // Auth Root
  auth: {
    url: "/auth",
    path: "auth",
    titleKey: "Login",
  },
  login: {
    url: "/auth/login",
    path: "login",
    titleKey: "Login",
  },
  deprecatedLogin: {
    url: "/auth/login/:userId",
    path: "login/:userId",
    titleKey: "Login",
  },
  verifyAccount: {
    url: "/auth/verify-account/:userId",
    path: "verify-account/:userId",
    titleKey: "Verify account",
  },
  verifyAnonymousAccount: {
    url: "/auth/verify-account",
    path: "verify-account",
    titleKey: "Verify account",
  },
  verifyCode: {
    url: "/auth/verify-code/:userId",
    path: "verify-code/:userId",
    titleKey: "Verify code",
  },
  verifyCodeFromUrl: {
    url: "/auth/verify-code/:userId/:contactType/:contactDetail/:code",
    path: "verify-code/:userId/:contactType/:contactDetail/:code",
    titleKey: "Verify code",
  },
  verifyCodeFromUrlWithCampaign: {
    url: "/auth/verify-code/:userId/:contactType/:contactDetail/:campaign/:code",
    path: "verify-code/:userId/:contactType/:contactDetail/:campaign/:code",
    titleKey: "Verify code",
  },
  // Account Root
  account: {
    url: "/account",
    path: "account",
    titleKey: "Account information",
  },
  accountMain: {
    url: "/account/:accountId",
    path: ":accountId",
    titleKey: "Account",
  },
  accountMainNoRedirect: {
    url: "/account/:accountId",
    path: ":accountId",
    titleKey: "Account",
  },
  accounts: {
    url: "/accounts",
    path: "accounts",
    titleKey: "Accounts",
  },
  accountDashboard: {
    url: "/account/:accountId/account-dashboard",
    path: ":accountId/account-dashboard",
    titleKey: "Dashboard",
  },
  dispute: {
    url: "/account/:accountId/dispute",
    path: ":accountId/dispute",
    titleKey: "Dispute",
  },
  disputeSuccess: {
    url: "/account/:accountId/dispute-success",
    path: ":accountId/dispute-success",
    titleKey: "Dispute success",
  },
  verificationRequest: {
    url: "/account/:accountId/verification-request",
    path: ":accountId/verification-request",
    titleKey: "Verification request",
  },
  picker: {
    url: "/account/:accountId/plans",
    path: ":accountId/plans",
    titleKey: "Picker",
  },
  educational: {
    url: "/account/:accountId/educational/:step",
    path: ":accountId/educational/:step",
    titleKey: "Educational",
  },
  questionnaireIntro: {
    url: "/account/:accountId/questionnaire-intro",
    path: ":accountId/questionnaire-intro",
    titleKey: "Questionnaire",
  },
  questionnaire: {
    url: "/account/:accountId/questionnaire",
    path: ":accountId/questionnaire",
    titleKey: "Questionnaire",
  },
  questionnaireLoader: {
    url: "/account/:accountId/questionnaire-loader",
    path: ":accountId/questionnaire-loader",
    titleKey: "Questionnaire",
  },
  presetPlanCheckout: {
    url: "/account/:accountId/checkout/plan",
    path: ":accountId/checkout/plan",
    titleKey: "Checkout",
  },
  paymentSuccess: {
    url: "/account/:accountId/payment-success",
    path: ":accountId/payment-success",
    titleKey: "Payment success",
  },
  managePaymentMethod: {
    url: "/account/:accountId/manage-payment-method",
    path: ":accountId/manage-payment-method",
    titleKey: "Manage payment method",
  },
  // Payment plan
  summaryPage: {
    url: "/account/:accountId/summary",
    path: ":accountId/summary",
    titleKey: "Summary",
  },
  partialPayment: {
    url: "/account/:accountId/partial-payment",
    path: ":accountId/partial-payment",
    titleKey: "Checkout",
  },
  guestPaymentPlanRoot: {
    url: "/guest-checkout",
    path: "guest-checkout",
    titleKey: "Checkout",
  },
  guestPaymentPlanCheckout: {
    url: "/guest-checkout/offer",
    path: "offer",
    titleKey: "Checkout",
  },
  guestCustomPaymentPlanCheckout: {
    url: "/guest-checkout/:paymentPlanId",
    path: ":paymentPlanId",
    titleKey: "Checkout",
  },
  guestMatrixPaymentPlanCheckout: {
    url: "/guest-checkout/matrix/offer",
    path: "matrix/offer",
    titleKey: "Checkout",
  },
  guestPaymentRoot: {
    url: "/guest-payment",
    path: "guest-payment",
    titleKey: "Guest payment",
  },
  guestPaymentCheckout: {
    url: "/guest-payment/:token",
    path: ":token",
    titleKey: "Guest payment",
  },
  guestPaymentSuccess: {
    url: "/guest-checkout/payment-success",
    path: "payment-success",
    titleKey: "Payment success",
  },
  hardshipIntro: {
    url: "/account/:accountId/hardship-intro",
    path: ":accountId/hardship-intro",
    titleKey: "Hardship intro",
  },
  hardshipPlans: {
    url: "/account/:accountId/hardship-plans",
    path: ":accountId/hardship-plans",
    titleKey: "Hardship plans",
  },
  questionnaireHardshipPlans: {
    url: "/account/:accountId/questionnaire-hardship-plans",
    path: ":accountId/questionnaire-hardship-plans",
    titleKey: "Lower monthly options",
  },
  expiredCampaign: {
    url: "/account/:accountId/expired-campaign",
    path: ":accountId/expired-campaign",
    titleKey: "Expired campaign",
  },
  profile: {
    url: "/profile",
    path: "profile",
    titleKey: "Profile",
  },
};

export {consumerUrls as urls};
